export default {"src":"https://images-cdn.curipod.com/d-23ae3965/_next/static/media/emojiBackground1.c6354451.svg","height":257,"width":356};